<template>
	<span class="interfaceElement">
		<variableInsertionInput v-if="!hideVariableToggle" @inputIsVariable="
			(isVariable) => {
				if (!isVariable) {
					//If toggling field to constant then reset parameter value to default
					form[property.name] = property.default;
				}
				inputIsVariable = isVariable;
			}
		" @contentModified="
			(contentString) => {
				form[property.name] = contentString;
			}
		" :integrationInterface="integrationInterface" :inputIsVariable="inputIsVariable" :content="form[property.name]"
			:property="property" />
		<el-select :disabled="readOnlyMode || workflow.access !== 'admin'"
			@change="$emit('credChange', localCrendentialId)" clearable v-if="property.type === 'credentialOptions'"
			no-data-text="No credentials found" no-match-text="No credentials found" style="width: 100%"
			v-model="localCrendentialId" placeholder="Select credential">
			<el-option :key="option.id" v-for="option in property.options" :label="option.name"
				:value="option.id"></el-option>
		</el-select>
		<el-button id="wf-tour-configure-credential-btn" :disabled="readOnlyMode || workflow.access !== 'admin'" @click="$emit('launchNewCredModal')"
			style="display: flex; margin-left: auto; padding-bottom: 0px" v-if="property.type === 'credentialOptions'"
			type="text">
			Configure New Credential
		</el-button>
		<span v-if="!inputIsVariable">
			<el-color-picker v-if="property.type === 'color'" v-model="form[property.name]"></el-color-picker>
			<jsonInput @jsonModified="
				(jsonAsString) => {
					form[property.name] = jsonAsString;
				}
			" :json="form[property.name]" v-if="property.type === 'json'" />
			<el-date-picker style="width: 100%" v-if="property.type === 'dateTime'" v-model="form[property.name]"
				type="datetime" placeholder="Select date and time">
			</el-date-picker>
			<el-input v-if="property.type === 'resourceLocator'" :placeholder="property.modes[0].placeholder || ''"
				@keyup.native="
					() => {
						form[property.name] = buildUrl(property);
					}
				" v-model="localVal">
				<el-select style="min-width: 100px" v-model="property.modes[0].name" slot="prepend"
					placeholder="Select">
					<el-option :key="option.name" v-for="option in property.modes" :label="option.displayName"
						:value="option.name"></el-option>
				</el-select>
			</el-input>
			<multiValueInput :form="form" :property="property"
				v-if="property.type === 'string' && property.typeOptions && property.typeOptions.multipleValues" />
			<javascriptEditorInput @codeMutation="
				(codeString) => {
					form[property.name] = codeString;
				}
			" :code="form[property.name]"
				v-if="property.type === 'string' && property.typeOptions && property.typeOptions.editor" />
			<el-input :rows="2" :type="property.typeOptions && property.typeOptions.password ? 'password' : 'textarea'"
				autocomplete="new-password"
				:show-password="property.typeOptions && property.typeOptions.password ? true : false" v-if="
					property.type === 'string' &&
					(!property.typeOptions || (!property.typeOptions.multipleValues && !property.typeOptions.editor))
				" :placeholder="property.placeholder || ''" v-model="form[property.name]"></el-input>
			<el-switch v-if="property.type === 'boolean'" v-model="form[property.name]"> </el-switch>
			<el-input-number style="width: 100%" :precision="property.typeOptions && property.typeOptions.numberPrecision
				? property.typeOptions.numberPrecision
				: 0
				" :placeholder="property.placeholder || '0'" :min="property.typeOptions && property.typeOptions.minValue
					? property.typeOptions.minValue
					: retunInf('min')
					" :max="property.typeOptions && property.typeOptions.maxValue
						? property.typeOptions.maxValue
						: retunInf('max')
						" v-if="property.type === 'number'" v-model="form[property.name]" :step="1"></el-input-number>
			<flexibleSelectInput @authenticationValChanged="authenticationValChanged"
				v-if="property.type === 'options' || property.type === 'multiOptions'"
				:integrationInterface="integrationInterface" :property="property" :form="form" />
		</span>
		<collectionsInterfaceElement :rootForm="rootForm" :form="form[property.name]" :optionsObject="property"
			:integrationInterface="integrationInterface" v-if="property.type === 'collection'" />
		<fixedCollectionInterfaceElement :rootForm="rootForm" :form="form[property.name]"
			:fixedCollectionObject="property" :integrationInterface="integrationInterface"
			:hideVariableToggle="hideVariableToggle" v-if="property.type === 'fixedCollection'" />
		<el-alert style="margin-top: 10px" v-if="property.type === 'notice'" type="warning" :closable="false" show-icon>
			<div style="line-height: normal" v-html="property.displayName"></div>
		</el-alert>
		<p style="font-size: 10px; word-break: break-word; margin: 0px; line-height: 20px; margin-top: 5px"
			v-if="property.description && property.type !== 'fixedCollection'" v-html="property.description"></p>
		<p style="font-size: 10px; word-break: break-word; margin: 0px; line-height: 20px; margin-top: 5px"
			v-if="property.hint" v-html="'Hint: ' + property.hint"></p>
	</span>
</template>

<script>
import collectionsInterfaceElement from "./collectionsInterfaceElement.vue";
import fixedCollectionInterfaceElement from "./fixedCollectionInterfaceElement.vue";
import flexibleSelectInput from "./flexibleSelectInput.vue";
import multiValueInput from "./multiValueInput.vue";
import jsonInput from "./jsonInput.vue";
import variableInsertionInput from "./variableInsertionInput.vue";
import javascriptEditorInput from "./javascriptEditorInput.vue";
export default {
	name: "paramsInterfaceElement",
	components: {
		collectionsInterfaceElement,
		fixedCollectionInterfaceElement,
		flexibleSelectInput,
		multiValueInput,
		jsonInput,
		variableInsertionInput,
		javascriptEditorInput,
	},
	props: {
		property: Object,
		form: Object,
		rootForm: Object,
		integrationInterface: Object,
		credentialId: String,
		readOnlyMode: Boolean,
		workflow: Object,
		hideVariableToggle: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			localVal: "",
			localCrendentialId: "",
			inputIsVariable: false,
		};
	},
	beforeMount() {
		this.checkIfInputShouldBeVariable();
		this.localCrendentialId = this.workflow?.access === "admin" ? this.credentialId : "Credential Hidden";
		if (this.property.type === "resourceLocator") {
			if (
				this.property.modes.length &&
				this.property.modes[0].url &&
				(this.form[this.property.name].includes("https://") ||
					this.form[this.property.name].includes("http://"))
			) {
				//Is built up resource locator string, so extract value
				this.localVal = this.extractResourceLocatorValue(
					this.form[this.property.name],
					this.property.modes[0].url //reference url
				);
			} else {
				this.localVal = this.form[this.property.name];
			}
		}
	},
	methods: {
		extractResourceLocatorValue(resourceLocatorValue, referenceUrl) {
			const cleanedReferenceUrl = referenceUrl.replace(/^[^a-zA-Z]*https?:/, "https:");
			let escapedReferenceUrl = cleanedReferenceUrl.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
			escapedReferenceUrl = escapedReferenceUrl.replace(/\\{\\{.*?\\}\\}/, "([^/]+)");
			const regex = new RegExp(`^${escapedReferenceUrl}$`);
			const match = resourceLocatorValue.match(regex);
			return match ? match[1] : "";
		},
		checkIfInputShouldBeVariable() {
			const content = this.form[this.property.name];
			if (
				typeof content === "string" &&
				this.property.type !== "json" &&
				this.property.typeOptions?.editor !== "codeNodeEditor"
			) {
				if (content.search(/\{\{.*?\}\}|\[\[.*?\]\]/gs) >= 0) {
					//Variable reference exists so make the input variable
					this.inputIsVariable = true;
				} else {
					if (typeof this.property.default !== "string") {
						//If default is not a string and the param is a string with no variable then the param get reverted back to its property default
						this.form[this.property.name] = this.property.default;
					}
				}
			}
		},
		authenticationValChanged() {
			this.localCrendentialId = "";
			this.$emit("credChange", this.localCrendentialId);
		},
		buildUrl(property) {
			//We build the url automatically for the resourceLocator property if buildUrl flag is set to true
			if (property.modes.length && property.modes[0].url && property.modes[0].buildUrl) {
				let mode = property.modes[0];
				if (this.localVal.length) {
					return mode.url.substr(1).replace(/\{\{.*?\}\}/g, this.localVal);
				} else {
					return "";
				}
			} else {
				return this.localVal;
			}
		},
		retunInf(type) {
			if (type === "min") {
				return -Infinity;
			} else {
				return Infinity;
			}
		},
	},
};
</script>

<style scoped></style>
